import React from "react";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import CardNews from "../CardNews";

import {
  FacebookIcon,
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { graphql, useStaticQuery } from "gatsby";

interface PostContentProps {
  title: string;
  date: string;
  body: string;
  pathNews: string;
  image: string;
}

const mes = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
];

const PostContent: React.FC<PostContentProps> = ({
  title,
  date,
  body,
  pathNews,
  image,
}) => {
  const data = useStaticQuery(graphql`
    {
      allSitePage(limit: 3) {
        nodes {
          id
          path
          context {
            slug
            date
            title
            body
            image
          }
        }
      }
    }
  `);

  const dateConverted = new Date(date);
  const paragraphs = body.split("</p>");

  const contentPorImg = paragraphs.map((p, i) => {
    const checkIfExistImg = p.search("<img");

    if (checkIfExistImg >= 0) {
      return true;
    }

    return false;
  });

  return (
    <div>
      <div className="container my-6">
        <div className="columns mx-0">
          <div className="column is-8 post-layout">
            <div className="mb-6">
              <h1 className="is-size-3-mobile">{title}</h1>
              <div className="my-4">
                publicado em:{" "}
                <span className="tag is-primary is-light has-text-weight-bold">
                  {`${dateConverted.getDate()} de ${
                    mes[dateConverted.getMonth()]
                  } de ${dateConverted.getFullYear()}`}
                </span>
              </div>
            </div>

            <div className="post-content">
              <Zoom>
                <figure className="image is-flex is-flex-direction-column my-4">
                  <img
                    className="object-fit image-hero-news"
                    src={image}
                    alt="Imagem da notícia"
                  />
                </figure>
              </Zoom>

              {paragraphs.map((p, i) => {
                if (!contentPorImg[i])
                  return (
                    <div key={i} dangerouslySetInnerHTML={{ __html: p }}></div>
                  );
                else {
                  const urlSplit = p.split(" ");

                  let pathImg = "";
                  let altImg = "";

                  {
                    urlSplit.forEach((att) => {
                      const posSrc = att.search('src="');
                      const posAlt = att.search('alt="');

                      if (posSrc >= 0) {
                        pathImg = att.substring(5, att.length - 1);
                        return;
                      }

                      if (posAlt >= 0) {
                        altImg = att.substring(5, att.length - 1);
                        return;
                      }
                    });
                  }

                  return (
                    <Zoom key={i}>
                      <figure className="image is-flex is-flex-direction-column my-4">
                        <img
                          className="object-fit"
                          src={pathImg}
                          alt={altImg}
                        />
                        <figcaption className="mx-auto">
                          {altImg || (
                            <>
                              Aqui vai a legenda. use <code>alt=""</code>.
                            </>
                          )}
                        </figcaption>
                      </figure>
                    </Zoom>
                  );
                }
              })}
            </div>
          </div>

          <div className="column mt-4">
            <div className="last-news-section">
              <h3>Veja também</h3>

              <ul>
                <li>
                  {data.allSitePage.nodes.map((noticia, i) => (
                    <CardNews
                      key={i}
                      slug={noticia.context.slug}
                      title={noticia.context.title}
                      date={noticia.context.date}
                      body={noticia.context.body}
                      image={noticia.context.image}
                    />
                  ))}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="container mb-6 pl-4">
        <small className="text-bold is-uppercase">Compartilhar:</small>
        <div className="icons-shared-container mt-3">
          <FacebookShareButton url={pathNews}>
            <FacebookIcon size={38} round={true} />
          </FacebookShareButton>

          <WhatsappShareButton url={pathNews}>
            <WhatsappIcon size={38} round={true} />
          </WhatsappShareButton>

          <TwitterShareButton url={pathNews}>
            <TwitterIcon size={38} round={true} />
          </TwitterShareButton>

          <TelegramShareButton url={pathNews}>
            <TelegramIcon size={38} round={true} />
          </TelegramShareButton>
        </div>
      </div>
    </div>
  );
};

export default PostContent;
